import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface CostEvolutionData {
    epoch: number;
    date: string;
    totalCost: number;
    name: string;
}

interface CostEvolutionChartProps {
    data: CostEvolutionData[];
}

const CostEvolutionChart: React.FC<CostEvolutionChartProps> = ({ data }) => {
    return (
        <div className="w-full h-[300px] bg-card rounded-lg p-4 border border-border">
            <h3 className="text-lg font-semibold mb-4 text-text-primary">Project Cost Evolution</h3>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={data}
                    margin={{
                        top: 10,
                        right: 30,
                        left: 0,
                        bottom: 0,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" opacity={0.3} />
                    <XAxis
                        dataKey="name"
                        stroke="var(--color-text-secondary)"
                        tick={{ fontSize: 10 }}
                        interval={0}
                        angle={-15}
                        textAnchor="end"
                        height={50}
                    />
                    <YAxis
                        stroke="var(--color-text-secondary)"
                        tickFormatter={(value) => `$${value}`}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: 'var(--color-card)',
                            borderColor: 'var(--color-border)',
                            color: 'var(--color-text-primary)'
                        }}
                        formatter={(value: number) => [`$${value.toFixed(2)}`, 'Total Cost']}
                    />
                    <Bar
                        dataKey="totalCost"
                        fill="var(--color-secondary)"
                        name="Total Cost"
                        radius={[4, 4, 0, 0]}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default CostEvolutionChart;
